import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePlanReviewSubmissionTypeMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeletePlanReviewSubmissionTypeMutation = { __typename?: 'mutation_root', delete_plan_review_submission_types_by_pk?: { __typename?: 'plan_review_submission_types', id: any } | null };


export const DeletePlanReviewSubmissionTypeDocument = gql`
    mutation deletePlanReviewSubmissionType($id: uuid!) {
  delete_plan_review_submission_types_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePlanReviewSubmissionTypeMutationFn = Apollo.MutationFunction<DeletePlanReviewSubmissionTypeMutation, DeletePlanReviewSubmissionTypeMutationVariables>;

/**
 * __useDeletePlanReviewSubmissionTypeMutation__
 *
 * To run a mutation, you first call `useDeletePlanReviewSubmissionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanReviewSubmissionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanReviewSubmissionTypeMutation, { data, loading, error }] = useDeletePlanReviewSubmissionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanReviewSubmissionTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanReviewSubmissionTypeMutation, DeletePlanReviewSubmissionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanReviewSubmissionTypeMutation, DeletePlanReviewSubmissionTypeMutationVariables>(DeletePlanReviewSubmissionTypeDocument, options);
      }
export type DeletePlanReviewSubmissionTypeMutationHookResult = ReturnType<typeof useDeletePlanReviewSubmissionTypeMutation>;
export type DeletePlanReviewSubmissionTypeMutationResult = Apollo.MutationResult<DeletePlanReviewSubmissionTypeMutation>;
export type DeletePlanReviewSubmissionTypeMutationOptions = Apollo.BaseMutationOptions<DeletePlanReviewSubmissionTypeMutation, DeletePlanReviewSubmissionTypeMutationVariables>;